import { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

import ReviewProgram from "../ReviewProgram/ReviewProgram";

import SelectedExcersises from "../SelectedExcersises";
//TODO check if we want to receive the id instead of the full program
const SidebarRight = ({program}) => {
  const [modalShow, setModalShow] = useState(false);

  const [exercisesToSave, setExercisesToSave] = useState(null);

  const [exercises, setExercises] = useState([]);

  const onSave = (exs) => {
    if(exs.length) {
      setExercisesToSave(exs);
      setModalShow(true);
    }
  }

  useEffect(() => {
    if(program) {
      const programExercises = [];
      program.programVideos.forEach((pv, index) => {
        let copy = {...pv.video}
        copy.elId = copy.id;
        copy.id = index;
        programExercises.push(copy);
      })
      setExercises(programExercises);
    }
  }, [program])

  return (
    <Row className="g-0 h-100">
      <Col className="bg-grey p-4">
        <h4 className="text-center pb-4">Your Program</h4>
        <SelectedExcersises onSave={onSave} exercises={exercises} setExercises={setExercises} />
      </Col>

      <ReviewProgram show={modalShow} onHide={() => setModalShow(false)} exercises={exercisesToSave} program={program} />
    </Row>
  );
};

export default SidebarRight;
